<template>
  <div class="Tracker-Mobile">
    <v-container fluid grid-list-md>
      <v-layout row wrap justify-center>
        <v-flex xs12>
          <v-card>
            <v-tabs horizontal>
              <v-tab> Mapa </v-tab>
              <v-tab>Configuracion </v-tab>
              <v-tab-item>
                <v-card>
                  <v-card-text>
                  <div class="text-center" @click="clean()">
                    <v-btn
                      rounded
                      color="primary"
                      dark
                    >
                      Limpiar
                    </v-btn>
                  </div>
                  <br>
                  <v-flex xs12 md7>
                    <v-autocomplete
                      :items="tinfo"
                      v-model="deviceIdTrack"
                      label="Dispositivo"
                      color="secondary"
                      item-text="deviceId"
                      hide-no-data
                      hide-selected
                      chips
                      return-object
                      deletable-chips
                      v-on:change="buscarDevice()"
                      @input="searchInput=null"
                      :search-input.sync="searchInput">
                    </v-autocomplete>
                  </v-flex>

                  <v-card v-if="deviceIdTrack">
                    <v-card-title class="title">
                    Tracking de rutas IK
                    <v-spacer/>

                    <v-text-field
                      :disabled="infoDevTrack.length < 0"
                      v-model="searchRuta"
                      append-icon="search"
                      label="Buscar"
                      single-line
                      hide-details
                    ></v-text-field>
                    <v-spacer/>
                  </v-card-title>
                  <v-card-text>
                    <v-data-table
                      dense
                      :headers="header"
                      :items="infoDevTrack"
                      :search="searchRuta"
                      no-results-text="No se encontro el término buscado"
                      no-data-text="No hay datos disponibles"
                      multi-sort
                      class="elevation-1"
                    >
                      <template v-slot:items="props">
                        <td >{{ props.item.deviceId}}</td>
                        <td >{{ props.item.fecha}}</td>
                        <td >{{ props.item.hora}}</td>
                        <td class="justify-center layout px-0">
                          <v-icon color="info" @click="drawMap(props.item)">
                            edit
                          </v-icon>
                        </td>
                      </template>
                    </v-data-table>
                    <p>{{this.infoDevTrack.track_id}}</p>
                  </v-card-text>
                  </v-card>
                  <br><br><br>

                  <template>
                    <l-map style="height: 300px; z-index: 0"
                    v-if="deviceIdRuta"
                    :options="mapOptions"
                    :zoom="zoom"
                    :center="center"
                    >
                      <l-tile-layer
                      :url="url"
                      :attribution="attribution">
                      </l-tile-layer>
                      <l-polyline :lat-lngs="deviceListRuta" :color="polyline.color">
                      </l-polyline>
                    </l-map>
                  </template>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card-title class="title">
                  Tracking de dispositivos IK
                  <v-spacer/>

                  <v-text-field
                    :disabled="tdevices.length < 0"
                    v-model="search"
                    append-icon="search"
                    label="Buscar"
                    single-line
                    hide-details
                  ></v-text-field>
                  <v-spacer/>
                </v-card-title>
                <v-card-text>
                  <v-data-table
                    dense
                    :headers="headers"
                    :items="tdevices"
                    :search="search"
                    no-results-text="No se encontro el término buscado"
                    no-data-text="No hay datos disponibles"
                    multi-sort
                    class="elevation-1"
                  >
                    <template v-slot:items="props">
                      <td >{{ props.item.referencia}}</td>
                      <td >{{props.item.deviceId}}</td>
                      <td >{{ props.item.intervalo}}</td>
                      <td >{{ props.item.service_enable}}</td>
                      <td class="justify-center layout px-0">
                        <v-icon color="info" @click="editUser(props.item)">
                          edit
                        </v-icon>
                        <v-icon color="error" @click="deleteUser(props.item)">
                          delete
                        </v-icon>
                      </td>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-tab-item>
            </v-tabs>
          </v-card>

        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { LMap, LTileLayer, LPolyline } from 'vue2-leaflet'
export default {
  name: `Tracker-Mobile`,
  components: {
    LMap,
    LTileLayer,
    LPolyline
  },
  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.project = this.$store.state.actualProject
    this.getTrackerMobile()
    this.getTrackerInfoMobile()
    this.getTrackerDataMobile()
  },
  data: function () {
    return {
      headers: [
        { text: 'Referencia', value: 'referencia' },
        { text: 'DeviceId', value: 'deviceId' },
        { text: 'Intervalo', value: 'intervalo' },
        { text: 'Service', value: 'service_enable' },
        { text: 'Acciones', value: 'acciones' }
      ],
      header: [
        { text: 'Device', value: 'deviceId' },
        { text: 'Fecha', value: 'fecha' },
        { text: 'Hora', value: 'hora' }
      ],
      tdevices: [],
      tOneRoute: [],
      deviceListRuta: [],
      tinfo: [],
      searchInput: '',
      search: '',
      searchRuta: '',
      tinfoAux: [],
      deviceIdTrack: null,
      deviceIdRuta: null,
      infoDevTrack: [],
      tdata: [],
      backConf: {
        pathTrackDvs: '/tracker/track_devices',
        pathTrackInfo: '/tracker/track_info',
        pathTrackData: '/tracker/track_data'
      },
      zoom: 17,
      latitudMapa: 0,
      longitudMapa: 0,
      center: [],
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
    '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      withTooltip: [],
      currentZoom: 11.5,
      currentCenter: [],
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5
      },
      polyline: {
        color: 'purple'
      }
    }
  },

  methods: {
    getTrackerMobile () {
      let request = {
        method: 'get',
        data: {},
        url: this.backConf.pathTrackDvs
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.tdevices = t.tdevices.concat(resp.data)
        })
        .catch(err => console.error(err))
    },

    getTrackerOneMobile () {
      let request = {
        method: 'get',
        data: {},
        url: this.backConf.pathTrackDvsOne
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.tOneRoute = t.tOneRoute.concat(resp.data)
        })
        .catch(err => console.error(err))
    },

    getTrackerInfoMobile () {
      let request = {
        method: 'get',
        data: {},
        url: this.backConf.pathTrackInfo
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.tinfoAux = t.tinfoAux.concat(resp.data.results)
          let tamaño = resp.data.count
          for (var i = 0; i < tamaño; i++) {
            if (t.tinfoAux[i].ruta != null) {
              t.tinfo = t.tinfo.concat(resp.data.results[i])
            }
          }
          for (var k = 0; k < t.tinfo.length; k++) {
            for (var j = 0; j < t.tdevices.length; j++) {
              if (t.tinfo[k].deviceId === t.tdevices[j].deviceId) {
                t.tinfo[k].deviceId = t.tdevices[j].referencia
              }
            }
          }
        })
        .catch(err => console.error(err))
    },

    getTrackerDataMobile () {
      let request = {
        method: 'get',
        data: {},
        url: this.backConf.pathTrackData
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.tdata = t.tdata.concat(resp.data)
        })
        .catch(err => console.error(err))
    },

    buscarDevice: function (e) {
      if (this.deviceIdTrack != null) {
        const len = this.tinfo.length
        var rutaDevice = []
        for (var i = 0; i < len; i++) {
          if (this.tinfo[i].deviceId === this.deviceIdTrack.deviceId) {
            rutaDevice.push(this.tinfo[i])
          }
        }
        this.infoDevTrack = rutaDevice
      }
    },

    drawMap (infoRuta) {
      this.deviceIdRuta = true
      const len = infoRuta.ruta.coordinates.length
      var ruta = []
      var list = []
      for (var j = 0; j < len; j++) {
        list = infoRuta.ruta.coordinates[j]
        var pri = list[0]
        var seg = list[1]
        ruta.push([seg, pri])
      }
      this.center = ruta[0]
      this.currentCenter = ruta[0]
      this.withTooltip = ruta[0]
      this.deviceListRuta = ruta
    },

    clean () {
      this.deviceIdTrack = null
      this.deviceIdRuta = null
    }
  }
}
</script>
